import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle, CheckCircle2 } from 'lucide-react';
export function ObjectionsSection() {
  return <section className="py-14 px-6 bg-[#2D3A4A] text-[#FFFBF5]" data-id="element-22">
      <div className="max-w-4xl mx-auto" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-24">
          <div className="flex items-center justify-center mb-4" data-id="element-25">
            <HelpCircle className="w-10 h-10 text-[#C4704B] mr-3" data-id="element-26" />
            <h2 className="text-3xl md:text-4xl font-bold font-serif" data-id="element-27">
              ¿Y si mi hijo no quiere?
            </h2>
          </div>
          <p className="text-center text-xl text-[#FFFBF5]/80 max-w-2xl mx-auto mb-6" data-id="element-28">
            Está contemplado. El objetivo no es que salga perfecto. El objetivo
            es que se repita mañana.
          </p>

          <div className="grid md:grid-cols-3 gap-4" data-id="element-29">
            {['Versión más fácil (para 1–2 años o días de cero paciencia)', 'Versión más desafiante (para 3–4 o cuando está más dispuesto)', 'Señal de salida para terminar sin pelea'].map((item, i) => <div key={i} className="bg-[#FFFBF5]/10 backdrop-blur-sm p-6 rounded-2xl border border-[#FFFBF5]/10" data-id="element-30">
                <CheckCircle2 className="w-6 h-6 text-[#8B9E7E] mb-4" data-id="element-31" />
                <p className="font-medium" data-id="element-32">{item}</p>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#FFFBF5] text-[#2D3A4A] p-6 md:p-8 rounded-[2.5rem] shadow-xl" data-id="element-33">
          <h3 className="text-2xl md:text-3xl font-bold mb-6 text-center font-serif" data-id="element-34">
            Por qué lo que ya probaste te falló <br data-id="element-35" />
            <span className="text-[#C4704B] italic" data-id="element-36">(y no es tu culpa)</span>
          </h3>

          <div className="space-y-5" data-id="element-37">
            <div className="flex flex-col md:flex-row gap-4" data-id="element-38">
              <div className="md:w-1/3" data-id="element-39">
                <h4 className="font-bold text-lg border-b-2 border-[#F5E6D0] inline-block mb-2" data-id="element-40">
                  1) Ideas sueltas
                </h4>
              </div>
              <div className="md:w-2/3" data-id="element-41">
                <p className="text-[#2D3A4A]/80" data-id="element-42">
                  Te dejan con el "trabajo invisible": elegir, preparar,
                  sostener.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-4" data-id="element-43">
              <div className="md:w-1/3" data-id="element-44">
                <h4 className="font-bold text-lg border-b-2 border-[#F5E6D0] inline-block mb-2" data-id="element-45">
                  2) Mega packs
                </h4>
              </div>
              <div className="md:w-2/3" data-id="element-46">
                <p className="text-[#2D3A4A]/80" data-id="element-47">
                  Son grandes… y por eso mismo te aplastan. Te hacen sentir que
                  si no usás todo, "no valió".
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-4" data-id="element-48">
              <div className="md:w-1/3" data-id="element-49">
                <h4 className="font-bold text-lg border-b-2 border-[#F5E6D0] inline-block mb-2" data-id="element-50">
                  3) Juguetes didácticos
                </h4>
              </div>
              <div className="md:w-2/3" data-id="element-51">
                <p className="text-[#2D3A4A]/80" data-id="element-52">
                  Son caros, ocupan espacio y no resuelven lo principal:{' '}
                  <span className="font-bold" data-id="element-53">
                    qué hago hoy, en 15 minutos, con el niño que tengo hoy.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}